import React from 'react';

import { FormattedMessage } from 'react-intl';

import { downloadConnector } from 'depop/connectors';

function combineActions (mainAction, secondaryAction) {
  mainAction();
  secondaryAction();
}

const DownloadLink = ({ openDownload, onclick, ...props }) =>
  <a onClick={() => {
      openDownload();
      onclick();
    }}
    rel="noopener"
    {...props}>
    <FormattedMessage
      id="app.downloadLabel"
      description="Download Label"
      defaultMessage="Download App"
    />
  </a>;

export default downloadConnector(DownloadLink);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/DownloadLink.js